export const getTotalsForTheMonth = monthBasedDataArr => {
    let totalOrders = 0;
    let totalPaidOrders = 0;
    let totalBillingAmount = 0;
    let billedAccountsCount = 0;
    monthBasedDataArr.forEach(billingData => {
        totalOrders += billingData.numberOfOrders;
        totalPaidOrders += billingData.numberOfPaidOrders;
        totalBillingAmount += billingData.billableAmount;
    })
    billedAccountsCount = monthBasedDataArr.length;
    return {
        totalOrders, totalPaidOrders, totalBillingAmount, billedAccountsCount
    }
}

export const getTotalThirdPartyOrdersByWeek = weekBasedDataArr => {
    let total = 0;
    let totalPaid = 0;
    let outstandingAmount = 0;
    let billedAccountsCount = 0;

    weekBasedDataArr.forEach((data) => {
        total += data.totalAmount;
        totalPaid += data.paidAmount;
        outstandingAmount += data.unpaidAmount;
    })
    total = total.toFixed(2);
    totalPaid = totalPaid.toFixed(2);
    outstandingAmount = outstandingAmount.toFixed(2);
    billedAccountsCount = weekBasedDataArr.length;
    return {
        total, totalPaid, outstandingAmount, billedAccountsCount
    }
}

export const getTotalDueAndSavingForCurrentMonth = (billingDetails) => {
    let currentMonth = new Date();
    let targetDate;
    for (let date in billingDetails) {
        targetDate = new Date(date);
        if (currentMonth.getMonth() === targetDate.getMonth()) {
            const monthData = billingDetails[date];
            const totalDiscount = monthData.totalDiscountAmount ?? 0;
            const afterDiscountAmount = (monthData.totalBillingAmount - totalDiscount).toFixed(2);
            const discountedAmount = totalDiscount.toFixed(2);
            return {afterDiscountAmount, discountedAmount}
        }
    }
    return {afterDiscountAmount: "0", discountedAmount: "0"}
}

export const getTotalSavingForCurrentYear = (billingDetails) => {
    let currentMonth = new Date();
    let targetDate;
    let totalDiscount = 0;
    for (let date in billingDetails) {
        targetDate = new Date(date);
        if (currentMonth.getFullYear() === targetDate.getFullYear()) {
            totalDiscount += billingDetails[date].totalDiscountAmount ?? 0;
        }
    }
    return totalDiscount.toFixed(2);
}

export const getOrgNameBasedOnLevel = (adminDetails, levelsDetails) => {
    if (levelsDetails === null) return "";
    switch (adminDetails.getAdminLevel()) {
        case "ENTERPRISE":
            return levelsDetails.getEnterprise().getName();
            break;
        case "REGIONAL":
            return levelsDetails.getRegion().getName();
            break;
        case "SUB_REGIONAL":
            return levelsDetails.getSubRegion().getName();
            break;
    }
}

export const eachWordStartWithCapital = (str) => {
    str = str.replaceAll("_", " ");
    let strArr = str.split(" ");
    let newStrArr = strArr.map(st => st.charAt(0).toUpperCase() + st.slice(1).toLowerCase());
    return newStrArr.join(" ");
}

